(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helmstand-story"]) return;
  try {
    
(() => {
  const initialize = (root = document) => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('#helmstand-story video').forEach(video => {
      if (video.dataset.hsPlaybackReady) return;
      video.dataset.hsPlaybackReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.controls = true;
      video.pause();
      const prepare = () => {
        if (video.dataset.hsPrepared) return;
        video.dataset.hsPrepared = 'true';
        video.preload = video.hasAttribute('data-hs-scroll-autoplay') ? 'auto' : 'metadata';
        video.load();
      };
      const playVisible = () => {
        if (document.hidden || reduced.matches) return;
        prepare();
        video.play().catch(() => { video.controls = true; });
      };
      video.addEventListener('canplay', () => {
        if (video.dataset.hsVisible === 'true') playVisible();
      });
      if (reduced.matches) video.removeAttribute('autoplay');
      if ('IntersectionObserver' in window) {
        const loader = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { prepare(); loader.unobserve(video); }
          });
        }, {rootMargin: '600px 0px', threshold: 0});
        loader.observe(video);
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
            video.dataset.hsVisible = visible ? 'true' : 'false';
            if (visible) playVisible();
            else video.pause();
          });
        }, { threshold: [0, 0.1, 0.25] });
        observer.observe(video);
      } else if (!reduced.matches) playVisible();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (video.dataset.hsVisible === 'true') playVisible();
      });
      reduced.addEventListener('change', () => {
        if (reduced.matches) video.pause();
        else if (video.dataset.hsVisible === 'true') playVisible();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitdock-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root = document) => {
  const videos = root.querySelectorAll('.pd-home video:not([data-pd-ready])');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  videos.forEach(video => {
   video.dataset.pdReady = 'true';
   video.muted = true;
   if (reduced.matches || !('IntersectionObserver' in window)) return;
   let visible = false;
   const play = () => { if (visible && video.paused) video.play().catch(() => {}); };
   const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     visible = entry.isIntersecting;
     if (visible) { if (video.preload === 'none') { video.preload = 'metadata'; video.load(); } play(); }
     else video.pause();
    });
   }, {threshold:0.2});
   observer.observe(video);
   video.addEventListener('canplay',play);
   document.addEventListener('shopify:section:unload',event => {if(event.target.contains(video)) observer.disconnect();},{once:true});
  });
 };
 init();
 document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
